import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {ROUTES} from '../../configs/routes';
import userImg from '../../assets/images/required/user.png';
import {ActionRouteNavigate} from '../../store/actions/actions-route';
import {ActionSignOut} from '../../store/actions/actions-user';
import {getUserNameFromString} from '../../services/common';
import {t} from '../../services/i18nHandler';

const SidebarUser = ({user, loggedIn}) => {
  const userAvatar = loggedIn ? user.photoUrl || userImg : userImg;
  const userNameData = getUserNameFromString(user.name);

  return (
    <div className="sidebar__user">
      <div className="user-image">
        <img src={userAvatar} alt="" />
      </div>
      {(!loggedIn || !user.role)
      && (
        <div className="enter-links">
          <Link to={ROUTES.LOGIN.route}>{t('nav.logIn')}</Link>
          <span className="enter-links__divider">{t('delimeter.or')}</span>
          <Link to={ROUTES.REGISTRATION.route}>{t('nav.reg')}</Link>
        </div>
      )}
      {loggedIn && user.name
        && (
          <div className="user-name">
            {userNameData.lastName}
            {' '}
            {userNameData.firstName}
            {' '}
            <br />
            {' '}
            {userNameData.middleName}
          </div>
        )}
    </div>
  );
};

SidebarUser.defaultProps = {
  loggedIn: false,
  user: {},
};

SidebarUser.propTypes = {
  loggedIn: PropTypes.bool,
  user: PropTypes.shape({}),
};

function mapStateToProps({rUser, rSession}) {
  return {
    user: rUser || {},
    loggedIn: rSession.LOGGED_IN,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionRouteNavigate,
    ActionSignOut,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarUser);
